import { createFileRoute, redirect } from '@tanstack/react-router';
import { ModernLoginPage } from '../components/auth/ModernLoginPage';

export const Route = createFileRoute('/')({
  component: ModernLoginPage,
  beforeLoad: ({ context }: any) => {
    // If user is already authenticated, redirect to dashboard
    if (context.auth?.isAuthenticated) {
      throw redirect({ to: '/dashboard' });
    }
  },
});
